// affiliateId and issuerName values copied from app-site
export default {
  chase: {
    issuerName: 'chase',
    affiliateId: 9, // Linkshare
    componentName: 'PrequalChase',
  },
  american_express: {
    issuerName: 'amex',
    affiliateId: 1, // Commission Junction (CJ)
    componentName: 'PrequalAmex',
  },
};
